<template>
  <div>
    <b-skeleton-table
      v-if="isLoading"
      :rows="5"
      :columns="5"
    />

    <b-table
      v-else-if="!isLoading"
      ref="refInvoiceListTable"
      :items="externalProducts.data"
      responsive
      :fields="tableFields"
      primary-key="id"
      show-empty
      empty-text="No matching records found"
      class="position-relative mh-160"
    >

      <!-- Column: Name -->
      <template #cell(name)="data">
        {{ data.item.name }}
      </template>

      <!-- Column: Price -->
      <template #cell(url)="data">
        <div
          class="card-text text-truncate"
          style="width: 300px"
        >
          <a
            :href="data.item.url"
            target="_blank"
          >{{ data.item.url }}</a>
        </div>
      </template>

      <!-- Column: total_registry_products -->
      <template #cell(total_registry_products)="data">
        {{ data.item.total_registry_products }}
      </template>
    </b-table>

    <div
      class="mx-2 mb-2"
    >
      <pagination
        :data="externalProducts.meta"
        action="registry/getProductExternal"
      />
    </div>
  </div>
</template>

<script>
import {
  BTable,
  BSkeletonTable,
} from 'bootstrap-vue'
import { mapActions, mapState } from 'vuex'
import Pagination from '@/layouts/components/custom/Pagination.vue'

export default {
  components: {
    BTable,
    BSkeletonTable,
    Pagination,
  },
  data() {
    return {
      tableFields: [
        { key: 'name', label: 'Nama' },
        { key: 'url', label: 'Url' },
        { key: 'total_registry_products', label: 'Total Produk Registry' },
      ],
    }
  },
  computed: {
    ...mapState('registry', ['externalProducts', 'isLoading']),
    query() {
      return this.$route.query
    },
  },
  async created() {
    await this.getProductExternal(this.query)
  },
  methods: {
    ...mapActions('registry', ['getProductExternal']),
  },
}
</script>
